import { AuthProvider } from "./providers/AuthProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./theme/Layout";
import { Home } from "./app/Page";
import Signout from "./auth/Signout";
import InvoiceForOcr from "./app/invoice/[invoiceId]/Page";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const RETRY_DELAY = 1000;
const ATTEMPT_EXCEED_INDEX = 30000;
const RETRY_INCREASE = 2;
const DEFAULT_RETRY_COUNT = 3;
const RETRY_COUNT = import.meta.env.VITE_RETRY_COUNT ? +import.meta.env.VITE_RETRY_COUNT : DEFAULT_RETRY_COUNT;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // v5: only boolean or function
            retryDelay: failureCount => Math.min(RETRY_DELAY * RETRY_INCREASE ** failureCount, ATTEMPT_EXCEED_INDEX),
            retry: RETRY_COUNT
        }
    }
});

const App = () => {
    return (
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <Layout />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/signout" element={<Signout />} />
                        <Route path="/invoice/:invoiceId" element={<InvoiceForOcr />} />
                    </Routes>
                </AuthProvider>
            </QueryClientProvider>
        </BrowserRouter>
    );
};

export default App;
